import axios from "axios";
import { apiEndpoint } from "../config";
import refreshInterceptor from "./refreshInterceptor/refreshInterceptor";

const TransactionAPI = axios.create({
  baseURL: apiEndpoint.transactions,
  headers: {
    "content-type": "application/json",
  },
});

TransactionAPI.interceptors.request.use(refreshInterceptor);

export default TransactionAPI;
